// =============================================================================
// FILE STATUS HEADER  (lihat /app/memory/MASTER_BLUEPRINT.md A7)
// status   : ACTIVE
// version  : 1.0
// updated  : 2026-06-15
// replaces : -
// protected: NO  -> Helper API client. Jangan ubah base URL / env handling.
// =============================================================================

import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

// Auth uses a secure httpOnly cookie (set by the backend on login).
// withCredentials ensures the cookie is sent on every same-origin API call.
export const api = axios.create({ baseURL: API, withCredentials: true });

// Owner "Lihat sebagai" (preview): forward the impersonated role so the backend
// applies that role's DATA SCOPE too. Skipped for /auth/me (keeps real identity).
// Backend only honors this header when the real logged-in user is the Owner.
api.interceptors.request.use((config) => {
  try {
    const viewAs = localStorage.getItem("etams_view_as_role");
    const url = String(config.url || "");
    if (viewAs && !url.includes("/auth/me")) {
      config.headers = config.headers || {};
      config.headers["X-View-As-Role"] = viewAs;
    }
  } catch (e) { /* ignore */ }
  return config;
});

api.interceptors.response.use(
  (res) => res,
  (err) => {
    if (err.response && err.response.status === 401) {
      localStorage.removeItem("etams_user");
      if (!window.location.pathname.startsWith("/login") && !window.location.pathname.startsWith("/auth") && !window.location.pathname.startsWith("/v2")) {
        window.location.href = "/login";
      }
    }
    return Promise.reject(err);
  }
);

// PDF / document links open in a new tab via <a href>. The browser automatically
// sends the httpOnly auth cookie for same-origin requests, so no token in the URL.
export const fileUrl = (path) => `${API}${path}`;

// Download a binary file (e.g. Excel export) via authenticated blob request.
export const downloadFile = async (path, params, filename) => {
  const res = await api.get(path, { params, responseType: "blob" });
  const url = URL.createObjectURL(res.data);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(url);
};
